import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EquipmentContent } from 'src/app/domains/equipment/models';
import { EquipmentService } from 'src/app/domains/equipment/services';
import { User } from 'src/app/domains/users/models';
import { UsersService } from 'src/app/domains/users/services';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';

@Component({
  selector: 'gdp-add-handset-popup',
  templateUrl: './add-handset-popup.component.html',
  styleUrls: ['./add-handset-popup.component.scss']
})
export class AddHandsetPopupComponent implements OnInit {
  public equipment: EquipmentContent;
  public loading: boolean = false;
  public users: User[];
  public selectedUser;
  public form: UntypedFormGroup;
  public ipuiPattern = /^([0-9A-Fa-f]{10}|([0-9A-Fa-f]{2}-){4}[0-9A-Fa-f]{2}|([0-9A-Fa-f]{2}:){4}[0-9A-Fa-f]{2})$/;
  public loadingAdd: boolean = false;
  @Output() onAddHandset: EventEmitter<EquipmentContent> = new EventEmitter<EquipmentContent>();

  constructor(
    private activeModal: NgbActiveModal,
    private usersService: UsersService,
    private notification: NotificationService,
    private equipmentService: EquipmentService
    ) { }

  ngOnInit() {
    if (this.equipment.pbx) {
      this.loading = true;
      this.usersService.getUsers(this.equipment.pbx.company_id).subscribe((res: any) => {
        this.users = res;
        this.loading = false;
      }, () => {
        this.loading = false;
        this.close();
      });
    }

    this.form = new UntypedFormGroup({
      ipui: new UntypedFormControl(null, [
        Validators.required,
        Validators.pattern(this.ipuiPattern)
      ])
    });
  }

  isFieldValid(name: string) {
    return (
      !this.form.get(name).valid && this.form.get(name).touched
    );
  }

  onSelectUser(user) {
    this.selectedUser = user;
  }

  addHandset() {
    if (this.form.valid) {
      const ipui = this.form.get('ipui').value?.trim();
      this.loadingAdd = true;
      !this.selectedUser ? this.associateHandsetToEquipment(ipui) : this.associateHandsetToEquipmentAndUser(ipui);
    }
  }

  associateHandsetToEquipment(ipui: string) {
    this.equipmentService.associateHandsetToEquipment(
      this.equipment.mac_address,
      ipui,
      [
        {
          status: 409,
          message: 'equipment.details.modals.add-handset.error-exists'
        }
      ]
      )
      .subscribe((res: any) => {
      this.onAddHandset.emit(this.equipment);
      this.loadingAdd = false;
      this.notification.success('equipment.details.modals.add-handset.add-success');
      this.close();
    }, () => {
      this.loadingAdd = false;
      this.close();
    });
  }

  associateHandsetToEquipmentAndUser(ipui: string) {
    this.equipmentService.associateHandsetToEquipmentAndUser(
      this.equipment.pbx.id,
      this.selectedUser.pbxId,
      this.equipment.mac_address,
      ipui,
      [
        {
          status: 409,
          message: 'equipment.details.modals.add-handset.error-exists'
        }
      ]
      )
      .subscribe((res: any) => {
      this.onAddHandset.emit(this.equipment);
      this.loadingAdd = false;
      this.notification.success('equipment.details.modals.add-handset.add-success-user');
      this.close();
    }, () => {
      this.loadingAdd = false;
      this.close();
    });
  }

  close() {
    this.activeModal.close();
  }


}
